'use client'

import { useEffect } from 'react'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {

    console.error(error)
  }, [error])

  return (
    <div className='min-h-screen grid place-content-center'>
      <div className='bg-white text-[#1D4749] grid row-2 gap-5 justify-center p-8 rounded-xl '>
        <h2 className='font-bold text-2xl'>Oops...Something went wrong!</h2>
        <button
          className='bg-[#1D4749] p-2 rounded-md text-white'
          onClick={
            () => reset()
          }
        >
          Try again
        </button>
      </div>
    </div>
  )
}